import { render, staticRenderFns } from "./VariantNavigation.vue?vue&type=template&id=a426ca5a&scoped=true&lang=pug"
import script from "./VariantNavigation.vue?vue&type=script&lang=js"
export * from "./VariantNavigation.vue?vue&type=script&lang=js"
import style0 from "./VariantNavigation.vue?vue&type=style&index=0&id=a426ca5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a426ca5a",
  null
  
)

export default component.exports